import { render, staticRenderFns } from "./DiscoveryTablePrevButton.vue?vue&type=template&id=7656b568&scoped=true&"
import script from "./DiscoveryTablePrevButton.vue?vue&type=script&lang=js&"
export * from "./DiscoveryTablePrevButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7656b568",
  null
  
)

export default component.exports